module.exports = __webpack_public_path__ + "img/top7_img5.38875e92.png";